import { useSelector } from "react-redux";
import { ApplicationState } from "../rootStore";

export const useCompanyBranchReducer = () => useSelector((state: ApplicationState) => state.companyBranch);
